import { createContext } from 'react';

export type PaymentPlansContextType = {
    mainPath: string;
    subscribed: boolean;
    subscribedUntil: Date | null;
    tier: 'REGULAR' | 'PRO' | 'FREE' | 'ENTERPRISE',
    autoRenew: boolean
}

export const PaymentPlansContext = createContext<PaymentPlansContextType>({
    mainPath: '',
    subscribed: false,
    subscribedUntil: null,
    tier: 'FREE',
    autoRenew: false
})